import { createSelector, createSlice } from '@reduxjs/toolkit';
import { Accountant } from '../Model/Accountant';
import { Entrepreneur } from '../Model/Entrepreneur';
import { RootState } from './store';
import { readFromSessionStorage } from './util';
import { entrepreneurApi } from './entrepreneur';
import { storeApi } from './storeApi';

type AuthState = {
  user: Accountant | Entrepreneur;
  token: string | null;
  role: string | null;
};

const authSlice = createSlice({
  name: 'auth',
  initialState: { user: null, token: null } as AuthState,
  reducers: {
    saveToken: (state, { payload }) => {
      state.token = payload.token;
      sessionStorage.setItem('connect', payload.token);
    },
    logout: (state) => {
      state.user = null;
      state.role = null;
      state.token = null;
      sessionStorage.clear();
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(storeApi.endpoints.login.matchFulfilled, (state, { payload }) => {
      state.user = payload.user;
      state.role = payload.role;
      sessionStorage.setItem('role', payload.role);
      sessionStorage.setItem('user', JSON.stringify(payload.user));
    });

    builder.addMatcher(entrepreneurApi.endpoints.updateEntrepreneur.matchFulfilled, (state, { payload }) => {
      state.user = payload;
      sessionStorage.setItem('user', JSON.stringify(payload));
    });
  },
});

export const userSelector = createSelector(
  (state: RootState) => state.auth.user,
  (user) => user ?? readFromSessionStorage('user')
);

export const roleSelector = createSelector(
  (state: RootState) => state.auth.role,
  (role) => role ?? sessionStorage.getItem('role')
);

export const tokenSelector = createSelector(
  (state: RootState) => state.auth.token,
  (token) => {
    return token ?? sessionStorage.getItem('connect');
  }
);

export const { saveToken, logout } = authSlice.actions;

export const authReducer = authSlice.reducer;
